import React from 'react'

export default function HeaderSection({
  bigLogo, // 560x96
  description,
  findMoreLabel,
  images,
}) {
  return (
    <header id="main-header" data-scroll-index="0">
      <div className="overlay gradient-color" />
      <div id="particles-js" />

      <div className="header-section container">
        <div className="header-text">
          <div>
            {/*<!-- Your App name -->*/}
            <div className="title">
              <img className="responsive-img" src={bigLogo} alt="" />
            </div>

            {/*<!-- App Main Description -->*/}
            <h4 className="description">{description}</h4>

            {/*<!-- App Slogan -->*/}
            <a
              data-scroll-goto="7"
              className="slogan z-depth-1 hoverable waves-effect waves-light"
            >
              {findMoreLabel}
            </a>
          </div>
        </div>

        <div className="owl-carousel owl-header">
          {images.map(img => (
            <img key={img.alt} alt="" className="responsive-img" {...img} />
          ))}
        </div>
      </div>
    </header>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sections/HeaderSection.js